import { Col, Row, Table } from 'antd';
import { payrollApi } from 'Api/payroll';
import React, { useEffect, useState } from 'react';
import { FaFilePdf } from 'react-icons/fa';
import { PaySlipsImage } from 'utils/svgs';
import { toastText } from 'utils/utils';
import GlobalHeader from '../../GlobalHeader';
import './index.scss';

const { Column } = Table;

type Props = {
	selectedPayrollId: string;
	onlyView: boolean;
	usdCurrency: boolean;
	setIsUniversalLoading: any;
	//onDownloadPayslips?: () => void;
	headerData: any;
	showSteps: boolean;
};

const PaySlipTable: React.FC<Props> = (props: Props) => {
	const {
		selectedPayrollId,
		usdCurrency,
		setIsUniversalLoading,
		headerData,
		showSteps,
	} = props;

	const [paySlipData, setPaySlipData] = useState<any>([]);
	const [isLoading, setIsLoading] = useState<boolean>(false);
	const [selectedRowKeys, setSelectedRowKeys] = useState<React.Key[]>([]);
	const [page, setPage] = useState(1);
	const [totalRecords, setTotalRecords] = useState(0);
	const [pageSize, setPageSize] = useState(30);
	const [selectedPayslips, setSelectedPayslips] = useState<any[]>([]);

	const handlePayslips = (data: any) => {
		setSelectedPayslips(data);
	};

	const tableChangeHandler = (pagination: any, filters: any, sorter: any) => {
		setTotalRecords(pagination.total);
		setPage(pagination.current);
		setPageSize(pagination.pageSize);
	};

	const rowSelection = {
		getCheckboxProps: (record: any) => ({
			disabled: record.name === 'Disabled User',
		}),
		selectedRowKeys,
		onChange: (keys: React.Key[], selectedRows: any[]) => {
			setSelectedRowKeys(keys);
			handlePayslips(keys);
		},
	};

	const getPaySlips = async (payrollId: string) => {
		try {
			setIsLoading(true);

			setIsUniversalLoading(true);
			let response;
			response = await payrollApi.getPaySlipDetails({
				payrollId,
				page,
				pageSize,
			});

			if (response) {
				setPaySlipData(response.data.data.data);
				setTotalRecords(response.data.data.totalRecords);
			}
		} catch (err: any) {
			const errorMessage =
				err?.response?.data?.message ||
				'Something went wrong in fetching payslips';

			toastText(errorMessage, 'error');
		} finally {
			setIsLoading(false);

			setIsUniversalLoading(false);
		}
	};
	const handlePayslipClick = async (record: any) => {
		const employeeId = record.payrollEmployeeId;
		try {
			let response;
			if (usdCurrency) {
				response = await payrollApi.getSinglePaySlipUsd(
					selectedPayrollId,
					employeeId
				);
			} else {
				response = await payrollApi.getSinglePaySlip(
					selectedPayrollId,
					employeeId
				);
			}

			if (response && response.data) {
				const periodName =
					headerData.payPeriodName.match(/^(.*?)\s*\(/)?.[1] || '';
				const contentDisposition =
					response.headers['content-disposition'];
				let fileName = `${record.employeeName?.replace(
					/\s+/g,
					' '
				)} ${periodName} Payslip.pdf`;

				if (contentDisposition) {
					const fileNameMatch =
						contentDisposition.match(/filename="(.+)"/);
					if (fileNameMatch.length === 2) {
						fileName = fileNameMatch[1];
					}
				}
				const pdfBlob = new Blob([response.data], {
					type: 'application/pdf',
				});

				const pdfUrl = URL.createObjectURL(pdfBlob);
				const link = document.createElement('a');
				link.href = pdfUrl;
				link.setAttribute('download', fileName);
				document.body.appendChild(link);
				link.click();
				document.body.removeChild(link);
			}
		} catch (error: any) {
			const errorMessage =
				error?.response?.data?.message || 'Error fetching payslips';
			toastText(errorMessage, 'error');
		}
	};

	useEffect(() => {
		getPaySlips(selectedPayrollId);
	}, [selectedPayrollId, page, pageSize]);

	return (
		<>
			<Row>
				<Col span={24}>
					<GlobalHeader
						headerData={headerData}
						toggleRequired={true}
						fetchAllData={() => getPaySlips(selectedPayrollId)}
						isLoading={isLoading}
						selectedPaySlips={paySlipData.filter((item: any) =>
							selectedPayslips.includes(item.payrollEmployeeId)
						)}
						selectedPayrollId={selectedPayrollId}
						Payslip={true}
					/>
				</Col>
			</Row>
			<Row>
				<Col span={15}>
					<div className="pay-slip-table payroll-steps-table ">
						<Table
							dataSource={paySlipData}
							className="pay-slips"
							scroll={{
								y: showSteps
									? 'calc(90vh - 400px)'
									: 'calc(90vh - 279px)',
							}}
							pagination={{
								total: totalRecords,
								current: page,
								pageSize: pageSize,
								showSizeChanger: false,
								// onShowSizeChange: pageSizeHandler,
								pageSizeOptions: [10, 20, 50, 100, 200],
							}}
							rowKey={(record) => record.payrollEmployeeId}
							loading={isLoading}
							rowSelection={{ ...rowSelection, columnWidth: 1 }}
							onChange={tableChangeHandler}
						>
							<Column
								title="Employee Name | Code"
								dataIndex="optionalEmployeeId"
								key="optionalEmployeeId"
								width={'45%'}
								className="bg-white"
								render={(text, record: any) => (
									<>
										<span>{record.employeeName}</span> |{' '}
										<span className="color-purple">
											{record.employeeId}
										</span>
									</>
								)}
							/>

							<Column
								title="Pay Slips"
								width={'45%'}
								className="bg-white"
								dataIndex="paymentSlips"
								key="paymentSlips"
								render={(text, record: any) => (
									<>
										<a
											href={record.documentLink}
											target="_blank"
											rel="noopener noreferrer"
											onClick={() =>
												handlePayslipClick(record)
											}
										>
											<FaFilePdf
												color="#d32f2f"
												size={20}
											/>
										</a>
									</>
								)}
							/>
						</Table>
					</div>
				</Col>
				<Col span={2}></Col>
				<Col span={7}>
					<div>
						<PaySlipsImage />
					</div>
				</Col>
			</Row>
		</>
	);
};

export default PaySlipTable;
